var map = {
	"./AG.png": 8848,
	"./AJG.png": 2099,
	"./AN.jpg": 3992,
	"./AR.jpg": 8071,
	"./AS.jpg": 9218,
	"./AT.jpg": 3765,
	"./KJ.png": 1686,
	"./MM.jpg": 3950,
	"./NG.png": 8459,
	"./PS.png": 9080,
	"./RJ.jpg": 353,
	"./SC.png": 7529,
	"./SS.jpg": 7157,
	"./VT.jpg": 5471,
	"./VY.png": 73,
	"./amisha-singh.jpg": 7700,
	"./anubhav-yadav.JPG": 1911,
	"./astha-goel.jpg": 9928,
	"./avishi-tayal.jpeg": 1978,
	"./jalaj-sharma.jpeg": 4943,
	"./nandini-tyagi.jpg": 1138,
	"./parth.jpeg": 4701,
	"./rishabh.jpg": 9442,
	"./rishi.jpg": 5566,
	"./shreyansh-gupta.jpg": 6106,
	"./ujjawal-yadav.jpg": 3288,
	"./vedika-chauhan.jpg": 2244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8057;